<template>
    <dtg-dropdown>
        <dtg-dropdown-item
            v-bind="profileLinkProps"

            icon="user"
        >
            <div :class="b('item-profile-full-text')">
                <div :class="b('item-profile-name')">
                    {{ fullName }}
                </div>
                <div :class="b('item-profile-role')">
                    {{ rolesLabel }}
                </div>
            </div>
            <span :class="b('item-profile-text')">
                Mon profil
            </span>
        </dtg-dropdown-item>
        <dtg-dropdown-item
            v-bind="backofficeLinkProps"

            icon="dashboard"
        >
            MyDTG Manager
        </dtg-dropdown-item>
        <dtg-dropdown-item
            :href="supportUrl"

            icon="call"

            routed
        >
            Support
        </dtg-dropdown-item>
        <dtg-dropdown-item
            :href="aboutUrl"

            icon="information"

            routed
        >
            A propos de MyDTG
        </dtg-dropdown-item>
        <dtg-dropdown-item icon="turnOff" @click="onLogoutClick()">
            Déconnexion
        </dtg-dropdown-item>
    </dtg-dropdown>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import { useRouter } from 'vue-router';

import { DtgDropdown, DtgDropdownItem, events, getName, useBem } from 'dtg-components';
import { truthy } from 'dtg-shared/utils/truthy';

import { useAuth } from '@/composables/use-auth';

import { Route } from '@/router';

import { DtgHeaderDropdownEvents } from './types';

import styles from './style.module.scss';

export const props = {
    backofficeLinkProps: {
        type: Object,
        default: () => ({}),
    },

    profileLinkProps: {
        type: Object,
        default: () => ({}),
    },
} as const;

export default defineComponent({
    name: getName(styles),

    components: {
        DtgDropdown,
        DtgDropdownItem,
    },

    props,

    emits: events(['close', 'logout'])<DtgHeaderDropdownEvents>(),

    setup(props, { emit }) {
        const router = useRouter();
        const { user } = useAuth();

        const fullName = computed(() => {
            return [user.value?.firstName, user.value?.lastName].filter(truthy).join(' ');
        });

        const rolesLabel = computed(() => {
            return user.value?.rolesLabel ?? '';
        });

        const aboutUrl = computed(() => router.resolve({ name: Route.about }));
        const supportUrl = router.resolve({ name: Route.support });

        function onLogoutClick(): void {
            emit('logout');
        }

        return {
            b: useBem(styles),

            aboutUrl,
            supportUrl,
            rolesLabel,
            fullName,

            onLogoutClick,
        };
    },
});
</script>
